// Resolve against the reactive country catalogue, so rows recover when it loads
// after the customer request. Do not infer residence from a telephone prefix.
export function resolveCustomerCountry(value, countries = []) {
  const normalize = value => String(value || "").trim().toLowerCase();
  const raw = typeof value === "object" && value ? value : { countryname: value };
  const candidates = [raw.countryname, raw.isocode, raw.alpha2, raw.countryid]
    .map(normalize).filter(Boolean);
  const country = countries.find(country =>
    [country.countryname, country.isocode, country.alpha2, country.countryid]
      .some(key => candidates.includes(normalize(key)))
  ) || raw;
  const code = normalize(country.isocode || country.alpha2);
  return {
    country,
    countryCode: /^[a-z]{2}$/.test(code) ? (code === "uk" ? "gb" : code) : "",
    countryName: country.countryname && country.countryname !== "-"
      ? country.countryname : "Not provided",
  };
}
